/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsLocaleModule,
    ControlcenterMelcoModelsLocaleModuleFromJSON,
    ControlcenterMelcoModelsLocaleModuleFromJSONTyped,
    ControlcenterMelcoModelsLocaleModuleToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsLocaleModule>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule
     */
    list: Array<ControlcenterMelcoModelsLocaleModule>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModuleFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule {
    return ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModuleFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsLocaleModuleFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModuleToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsLocaleModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsLocaleModuleToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


